<template>
  <div>
    <Header></Header>
    <div class="my-account">
      <div class="content clearfix">
        <div class="template-menu">
          <div class="menu">
            <div class="mar-menu">
              <ul>
                <li @click="choiceMenus(0)">
                  <div class="list" :class="{ acitve: activeIndex == 0 }">
                    <a :class="{ acitve: activeIndex == 0 }">My Account</a>
                  </div>
                </li>
                <li @click="choiceMenus(1)">
                  <div class="list" :class="{ acitve: activeIndex == 1 }">
                    <a :class="{ acitve: activeIndex == 1 }">Payment</a>
                  </div>
                </li>
                <li @click="choiceMenus(2)">
                  <div class="list" :class="{ acitve: activeIndex == 2 }">
                    <a :class="{ acitve: activeIndex == 2 }">My Files</a>
                  </div>
                </li>
                <li @click="choiceMenus(4)">
                  <div class="list" :class="{ acitve: activeIndex == 4 }">
                    <a :class="{ acitve: activeIndex == 4 }">My Stores</a>
                  </div>
                </li>
                <li @click="choiceMenus(3)">
                  <div class="list" :class="{ acitve: activeIndex == 3 }">
                    <a :class="{ acitve: activeIndex == 3 }">Settings</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <MyFile v-if="activeIndex == 2"></MyFile>
        <MyAccount v-if="activeIndex == 0"></MyAccount>
        <Payments
          v-if="activeIndex == 1"
          :isShowAddCard="isShowAddCard"
        ></Payments>
        <Setting v-if="activeIndex == 3"></Setting>
        <MyStores v-if="activeIndex == 4"></MyStores>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../components/Header";
import MyFile from "../../components/account/MyFile";
import MyAccount from "../../components/account/MyAccount";
import Payments from "../../components/account/Payments";
import Setting from "../../components/account/Settings";
import MyStores from "../../components/account/MyStores";
export default {
  components: {
    Header,
    MyFile,
    MyAccount,
    Payments,
    Setting,
    MyStores
  },
  data() {
    return {
      activeIndex: 0,
      isShowAddCard: false
    };
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      this.activeIndex = this.$route.query.type ? this.$route.query.type : 0;
    }
  },
  beforeUpdate() {
    if (
      this.$route.query.isShowAddCard == "true" ||
      this.$route.query.isShowAddCard == true
    ) {
      this.isShowAddCard = true;
    } else {
      this.isShowAddCard = false;
    }
  },
  mounted() {
    console.log("...." + this.$route.query.type);
    this.activeIndex = this.$route.query.type ? this.$route.query.type : 0;
    if (this.$route.query.isShowAddCard) {
      this.isShowAddCard = true;
    }
  },
  methods: {
    choiceMenus(val) {
      this.activeIndex = val;
    }
  }
};
</script>
<style>
.template-menu {
  width: 240px;
}
.template-menu .menu {
  width: 100%;
  vertical-align: top;
  padding: 16px;
  font-size: 1rem;
  position: relative;
  margin-bottom: 16px;
  display: inline-block;
}
.template-menu .mar-menu {
  margin-top: 80px;
}
.template-menu ul {
  width: 204px;
}
.template-menu .mar-menu ul li .list {
  text-align: left;
  border-left-color: #106ebe;
  color: #106ebe;
  height: 36px;
  max-width: 188px;
  margin-bottom: 10px;
  border-left: 2px solid transparent;
  cursor: pointer;
}
.template-menu .mar-menu ul li .list:hover {
  background-color: #e5e7e9;
}
.template-menu .mar-menu ul li a:hover {
  color: #106ebe;
}
.template-menu .mar-menu ul li a {
  color: #1b1b1b;
  display: inline-block;
  height: 100%;
  padding: 7px 19px;
  width: 100%;
  line-height: 27px;
}
.template-menu .mar-menu ul li .list.acitve {
  border-left: 2px solid #106ebe;
  color: #106ebe;
}
.template-menu .mar-menu ul li a.acitve {
  color: #106ebe;
}
.my-account {
  position: relative;
  min-height: 100vh;
  margin: auto;
  background-color: #f7f7f7;
}
.my-account .content {
  max-width: 1168px;
  display: flex;
  margin: auto;
}
/* @media only screen and (max-width: 1200px) {
  .template-menu {
    display: none;
  }
} */
</style>
